export const validation = {
  blockTitleMaxChar: 100,
  blockParagraphMaxChar: 300,
  blocks: {
    min: 1,
    max:9
  }
}